import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { StatisticGraph } from "../../../../../shared/components/statistic/StatisticGraph"
import { useSupplier } from "../../../../supplier/supplierHooks"
import { CompanyReportsHomeQuery, fetchMeetingServiceNumberOfTransactions } from "../companyReportsHomeApi"

export function MeetingServicesOrdersStat({ periodInDays }: { periodInDays: number }) {
    const { supplierId } = useSupplier()

    const { data } = useApiQuery(fetchMeetingServiceNumberOfTransactions, {
        queryName: CompanyReportsHomeQuery.MEETING_SERVICE_NUMBER_OF_TRANSACTIONS,
        dependencies: {
            companyId: supplierId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })
    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.meetingServicePurchases.map((entry) => entry.date)}
            datasets={data.meetingServicePurchases.map((entry) => entry.purchasesSummary.numberOfOrders)}
            title={data?.reportSummary?.changeInPercentage}
        />
    )
}
